module.exports = __webpack_public_path__ + "27e558f12240ae356916435912f1aa55.png";